import { EAlertType } from '../../repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';
import { ITypedReduxAction, TThunkAction } from '../../types/redux';

export { EAlertType };

interface IViewData {
  headingType: string;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  source?: string;
  alert?: EAlertType;
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
}

export enum EAuthenticationActionType {
  Succeed = 'authentication/succeed',
  Cancelled = 'authentication/cancelled',
}

export type TAuthenticationSucceed = ITypedReduxAction<EAuthenticationActionType.Succeed>;
export type TAuthenticationCancelled = ITypedReduxAction<EAuthenticationActionType.Cancelled>;

export type TAuthenticationActions = TAuthenticationSucceed | TAuthenticationCancelled;
